module.exports = __webpack_public_path__ + "img/vegetable-spinach-190x100.ce5eadae.jpg";